import { Auction, GetOntologyType } from "core/types";
import { auctionBirthdatetoUnix } from "dsl/ecosystems/PatientForms/RehabForms/utils";
import Translations from "translations/types";
import {
  TransitionalCareFormGetters,
  getTransitionalCareDescriptionText,
} from "./utils";

export const getFormGetters = (
  getOntology: GetOntologyType,
  translations: Translations,
): TransitionalCareFormGetters => ({
  clinic_ik_number: (auction: Auction) =>
    auction.patient.careseeker?.banking_details?.ik_number,
  clinic_location_city: (auction: Auction) =>
    auction.patient.careseeker?.address?.city,
  clinic_location_street: (auction: Auction) =>
    auction.patient.careseeker?.address?.street,
  clinic_location_street_number: (auction: Auction) =>
    auction.patient.careseeker?.address?.street_number,
  clinic_location_zipcode: (auction: Auction) =>
    auction.patient.careseeker?.address?.zipcode,
  clinic_name: (auction: Auction) => auction.patient.careseeker?.name,
  legal_representative_last_name: (auction: Auction) =>
    auction.patient.profile?.communication?.guardian_contact_information
      ?.decrypted,
  patient_date_of_birth: auctionBirthdatetoUnix,
  patient_first_name: (auction: Auction) =>
    auction.patient?.profile?.first_name?.decrypted,
  patient_insurance_number: (auction: Auction) =>
    auction.patient.profile?.financing?.insurance_number?.decrypted,
  patient_last_name: (auction: Auction) =>
    auction.patient?.profile?.last_name?.decrypted,
  patient_location_city: (auction: Auction) =>
    auction.profile?.search_location?.city,
  patient_location_house_number: (auction: Auction) =>
    auction.profile?.search_location?.encrypted_house_number?.decrypted,
  patient_location_street: (auction: Auction) =>
    auction.profile?.search_location?.street,
  patient_location_zipcode: (auction: Auction) =>
    auction.profile?.search_location?.zipcode,
  prior_treatment_end_date: (auction: Auction) => auction.start_date,
  prior_treatment_hospital_id: (auction: Auction) =>
    auction.patient.external_id,
  transitional_care_description: (auction: Auction) =>
    getTransitionalCareDescriptionText({ auction, getOntology, translations }),
  transitional_care_start_date: (auction: Auction) => auction.start_date,
});
